import { SIZE_50 } from '@/lib/gridElements/size';
import { avgTimeWatchedPerVideoConfig } from '@/lib/analytics/kpis/youtube/avgTimeWatchedPerVideo';
import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';
import { KPIDefault } from '@/components/base/Kpi/KpiDefault';

import type { KpiType } from '@/lib/analytics/kpis/kpi.type';

export const mediaViewerVideoViewsAvgTimeWatchedConfig: KpiType<
    typeof MediaViewerKpiLoader,
    typeof KPIDefault
> = {
    ...avgTimeWatchedPerVideoConfig,
    id: 'average_view_duration',
    tooltip: null,
    size: SIZE_50,
    loader: MediaViewerKpiLoader
};
